import { graphql } from '@/gql';
import type { SendCallerSubscriptionHistoryMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendCallerSubscriptionHistory = async ({
  phoneNumber,
  fromDate,
  toDate,
  emailAddress,
}: SendCallerSubscriptionHistoryMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      fromDate,
      toDate,
      emailAddress,
    },
    mutation: graphql(`
      mutation SendCallerSubscriptionHistory($phoneNumber: String!, $fromDate: String!, $toDate: String!, $emailAddress: String!) {
        sendCallerSubscriptionHistory(phoneNumber: $phoneNumber, fromDate: $fromDate, toDate: $toDate, emailAddress: $emailAddress)
      }
    `),
  });

  return response.data?.sendCallerSubscriptionHistory ?? '';
};
